import type { IApply } from "@bbj-types/apply";
import { MenuItem, type MenuItemProps, Stack, Typography } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { useMemo } from "react";
import { getApplySubtext } from "./logics";

export interface IActionModalFieldApplyItemProps extends MenuItemProps {
  apply: IApply;
}

export const ActionModalFieldApplyItem = ({ apply, ...props }: IActionModalFieldApplyItemProps) => {
  const { settings } = useGlobalContext();

  const body = useMemo(
    () => getApplySubtext(apply, settings.settingsContractTypes),
    [settings.settingsContractTypes, apply]
  );

  return (
    <MenuItem sx={{ alignItems: "start" }} {...props}>
      <Stack
        sx={{
          rowGap: 0.5,
        }}
      >
        <Typography variant="subtitle2">{apply.offer.name}</Typography>
        <Typography
          variant="caption"
          sx={{
            color: "black.light",
          }}
        >
          {body}
        </Typography>
      </Stack>
    </MenuItem>
  );
};
